/**
 * @file: ai扫描组件
 * @author: wence
 */
import React, {PureComponent} from 'react';
import cn from 'classnames';
import PropType from 'prop-types';
import {bAntiBotSend} from '../../../util';
import exif from 'exif-js';

import DrawRegion from './drawRegion';
export default class AiScan extends PureComponent {
    static propTypes = {
        fetchChackAiImage: PropType.func,
        renderResultList: PropType.func,
        checkAiImageData: PropType.object,
        hiddenUrl: PropType.bool,
        onUploadBtnClick: PropType.func,
        beforeFetch: PropType.func,
        afterResponse: PropType.func,
        responseFormater: PropType.func,
    }

    constructor(props) {
        super(props);

        this.state = {
            errorMsg: '',
            resultList: [],
            inputValue: '',
            isShowCanvas: false,
            isCheckLoading: false,
            isImageLoading: false,
            isFetch: false
        };
    }

    componentDidMount() {
        const width = this.checkImageContainer.offsetWidth;
        const height = this.checkImageContainer.offsetHeight;
        this.draw = new DrawRegion({
            id: 'check-img',
            width,
            height
        });
    }

    addData(params, isFromdata) {
        let localData = {};
        try {
            bAntiBotSend();
            if (window.localStorage) {
                let localKey = '__abbaidu_20181211_cb';
                localData = JSON.parse(window.localStorage.getItem(localKey));
            }
        }
        catch (e) {
            localData = {};
        }

        if (isFromdata) {
            if (localData && localData.data) {
                params.append('data', localData.data);
            }
            if (localData && localData.key_id) {
                params.append('key_id', localData.key_id);
            }
            if (localData && localData.sign) {
                params.append('sign', localData.sign);
            }
        }
        else {
            if (localData && localData.data) {
                params.data = localData.data;
            }
            if (localData && localData.key_id) {
                params['key_id'] = localData.key_id;
            }
            if (localData && localData.sign) {
                params.sign = localData.sign;
            }
        }
    }

    fetchChackAiImage = (url, file, filename) => {
        this.setState({isCheckLoading: true});

        this.draw.drawImage({url}, async () => {
            let body = {};

            if (this.props.beforeFetch) {
                const cur = {
                    file: file,
                    filename: filename,
                    'upload_url': url
                };
                this.addData(cur);
                body = this.props.beforeFetch(cur);
            } else if (file) {
                body = new FormData();
                body.append('file', file, filename);
                this.addData(body, !!file);
            }
            else {
                body = {'upload_url': url};
                this.addData(body, !!file);
            }

            await this.props.fetchChackAiImage(body);

            const checkAiImageData = this.props.checkAiImageData || {};

            if (checkAiImageData.status === 0) {
                if (checkAiImageData.data && checkAiImageData.data.err_code && checkAiImageData.data.err_code === 0) {
                    const faceListLen = (checkAiImageData.data.face_list || []).length;
                    const curList = checkAiImageData.data.face_list.map((item, index) => {
                        return ({
                            location: item.location,
                            score: item.score,
                            textColor: item.score > 0.5 ? '#40C87F' : '#F5535B',
                            strokeStyle: item.score > 0.5 ? '#40C87F' : '#F5535B',
                            text: faceListLen === 1 ? '' : index + 1,
                            lineWidth: this.draw.getPixelRatio(2)
                        });
                    });

                    this.setState({resultList: curList, errorMsg: ''});
                    this.draw.drawStrokeInImage({list: curList});
                }
                else if (checkAiImageData.data && checkAiImageData.data.err_msg) {
                    this.setState({errorMsg: checkAiImageData.data && checkAiImageData.data.err_msg});
                }
                else {
                    const responseFormater = this.props.responseFormater;
                    const curList = responseFormater ? responseFormater(checkAiImageData.data) : checkAiImageData.data;
                    this.setState({resultList: curList, errorMsg: ''});
                    this.draw.drawStrokeInImage({list: curList});
                }
            }
            else {
                this.setState({errorMsg: checkAiImageData.description});
            }

            const afterResponse = this.props.afterResponse;
            if (afterResponse) {
                afterResponse(checkAiImageData);
            }

            this.setState({isCheckLoading: false, isFetch: true});
        }, () => {
            this.setState({errorMsg: '图片加载失败', isCheckLoading: false});
        });
    }

    onUploadFile = e => {
        const curfile = e.target.files[0];
        if (!curfile) {
            return;
        }
        this.draw.clearDraw();
        this.setState({isImageLoading: true, isShowCanvas: true, errorMsg: '', resultList: [], isFetch: false});
        this.getRealImage(curfile).then(([blob, file]) => {
            this.setState({isImageLoading: false});
            if (!(file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg')) {
                this.setState({errorMsg: '图片格式不正确，请重新上传'});
                return;
            }

            if (file.size > 1024 * 1024 * 5) {
                this.setState({errorMsg: '图片超大，请上传小于5M的图片'});
                return;
            }

            const readerFile = new FileReader();
            readerFile.readAsDataURL(file);
            readerFile.onload = e => {
                this.fetchChackAiImage(e.target.result, blob, file.name);
            };
            readerFile.onerror = function () {
                this.setState({errorMsg: '上传图片失败，请重新上传'});
            };
        }, () => {
            this.setState({isImageLoading: false});
        });
    }

    readFile(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.addEventListener('load', resolve);
            fileReader.addEventListener('error', reject);
            fileReader.readAsDataURL(file);
        });
    }

    compressImage(base64Data, orientation, quality, scale = 1) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.addEventListener('load', () => {
                const width = image.width * scale;
                const height = image.height * scale;
                const cvs = document.createElement('canvas');

                const context = cvs.getContext('2d');
                cvs.height = height;
                cvs.width = width;

                if (orientation && orientation !== 1) {
                    switch (orientation) {
                        case 6: // 旋转90度
                            cvs.height = width;
                            cvs.width = height;
                            context.rotate(Math.PI / 2);
                            context.drawImage(image, 0, -height, width, height);
                            break;
                        case 3: // 旋转180度
                            context.rotate(Math.PI);
                            context.drawImage(image, -width, -height, width, height);
                            break;
                        case 8: // 旋转-90度
                            cvs.height = width;
                            cvs.width = height;
                            context.rotate(3 * Math.PI / 2);
                            context.drawImage(image, -width, 0, width, height);
                            break;
                    }
                }
                else {
                    context.drawImage(image, 0, 0, width, height);
                }
                const dataURL = cvs.toDataURL('image/jpeg', quality);

                resolve(dataURL);
            });

            image.addEventListener('error', reject);
            image.src = base64Data;
        });
    }

    dataURLtoFile(base64Data, filename) {
        const arr = base64Data.split(',');
        // const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = window.atob(arr[1]);
        let len = bstr.length;
        const u8arr = new window.Uint8Array(len);
        while (len--) {
            u8arr[len] = bstr.charCodeAt(len);
        }
        const options = {type: 'image/jpeg'};
        const blob = new Blob([u8arr], options);
        return [blob, new File([u8arr], filename, options)];
    }

    getOriention(file) {
        return new Promise(resolve => {
            exif.getData(file, function () {
                resolve(exif.getTag(this, 'Orientation'));
            });
        });
    }

    getRealImage = async file => {
        if (!(file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg')) {
            this.setState({errorMsg: '图片格式不正确，请重新上传', isImageLoading: false});
            return;
        }
        const fileSize = 1024 * 1024 * 2;
        const scale = (fileSize / file.size) > 1 ? 1 : (fileSize / file.size);
        const orientation = await this.getOriention(file);
        const data = await this.readFile(file);
        const fdate = await this.compressImage(data.target.result, orientation, scale, scale);

        const files = this.dataURLtoFile(fdate, file.name);

        return files;
    }

    onChange = e => {
        this.setState({inputValue: e.target.value});
    }

    onUpload = e => {
        e.stopPropagation();
        e.preventDefault();

        this.draw.clearDraw();
        this.setState({isShowCanvas: true, isFetch: false});
        if (!/^(http|https):\/\//.test(this.state.inputValue)) {
            this.setState({errorMsg: '图片url无效，请更换图片后重新体验'});
            return;
        }

        this.fetchChackAiImage(this.state.inputValue);
        this.setState({errorMsg: '', inputValue: ''});
    }

    getNumber(number) {
        const n = number * 100;
        const newNum = n.toFixed(2);
        if (/^[0-9]+.00$/.test(newNum)) {
            return +newNum.split('.')[0];
        }

        if (/^[0-9]+.[0-9]{1}0$/.test(newNum)) {
            return +newNum.slice(0, 3);
        }

        return +newNum;
    }

    onFocus = () => {
        const navBar = document.querySelector('.nav-bar');

        if (navBar) {
            navBar.style.position = 'absolute';
        }
    }

    onBlur = () => {
        const navBar = document.querySelector('.nav-bar');

        if (navBar) {
            navBar.style.position = 'fixed';
        }
    }

    render() {
        return (
            <div>
                <div className={cn('product-function-canvas', {show: this.state.isShowCanvas})}>
                    <div ref={checkImageContainer => {
                        this.checkImageContainer = checkImageContainer;
                    }} className="check-img-container">
                        {this.state.isImageLoading
                            && <div className="image-loading-cantainer">
                                <div className="image-loading"></div>
                            </div>}
                        {this.state.isCheckLoading
                            && <div className="check-img-loading"></div>}
                        <canvas id="check-img" ref={checkImage => {
                            this.checkImage = checkImage;
                        }}></canvas>
                    </div>
                    {this.state.errorMsg
                        && <div className="product-function-canvas-tip">{this.state.errorMsg}</div>}
                    {!this.state.errorMsg
                        && this.state.resultList.length >= 0
                        && <div className={cn(
                            'product-function-canvas-result',
                            {simple: this.state.resultList.length <= 3 && this.state.resultList.length > 0})}>
                            {this.props.renderResultList
                                ? this.props.renderResultList(this.state.resultList, this.state.isFetch)
                                : this.state.resultList.map((item, index) => {
                                    const score = item.score;
                                    let isCur = score > 0.5;
                                    const curIndex = this.state.resultList.length === 1 ? '' : `${index + 1}.`;
                                    return (
                                        <div key={index}
                                            style={{color: isCur ? '#40C87F' : '#F5535B'}}
                                            className="product-function-canvas-result-item">
                                            {curIndex}{
                                                isCur ? '真脸' : '假脸'
                                            }{this.getNumber(isCur ? item.score : 1 - item.score)}%
                                        </div>
                                    );
                                })}
                        </div>}
                </div>

                <label className="product-function-upload" onClick={this.props.onUploadBtnClick}>
                    <input type="file" accept="image/jpeg,image/png,image/bmp" onChange={this.onUploadFile} />
                    <div className="product-function-upload-des">上传检测图片</div>
                </label>
                {!this.props.hiddenUrl
                    && <div className="product-function-blank">或</div>}
                {!this.props.hiddenUrl
                    && <div className="product-function-url">
                        <form onSubmit={this.onUpload}>
                            <input
                                type="text"
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                value={this.state.inputValue}
                                onChange={this.onChange}
                                placeholder="请输入图片url" />
                        </form>
                    </div>}
                <div className="product-function-des">
                    仅支持PNG、JPG、JPEG、BMP类型文件，图片大小不超过5M
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/product/components/aiScan.js